import { addDays } from 'date-fns';
import React, { useState } from 'react';
import { DayPicker } from 'react-day-picker';
import styled from 'styled-components';
import { Popover } from '../app/canvas/ui/Popover';
import { Icon } from '../concepts/resources/Icon';
import { BadgeButton } from './BadgeButton';
import { Colors } from './Colors';
import { DayPickerStyling } from './DayPickerStyling';
import { TableButton } from './TableButton';

export type DateButtonProps = {
    color?: string,
    value?: Date,
    placeholder?: string,
    prefix?: string,
    formatter?: (value: Date) => string,
    onChange?: (next: Date) => void,
};

const DateQuickOptions = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: .5rem;
    margin: 0rem 1rem 1rem;
    padding: .75rem;
    font-size: .875rem;
    border-top: solid .0625rem ${Colors.border};
`;

const DatePicker = ({ value, onChange }: { value: Date, onChange: (next: Date) => void }) => {

    const onPickInterval = (days: number) => {
        const date = new Date();
        date.setUTCHours(0, 0, 0, 0); // Set to 00:00 UTC
        onChange(addDays(date, days));
    };

    return <DayPickerStyling>
        <DayPicker
            mode="single"
            selected={value}
            defaultMonth={value}
            onSelect={x => onChange(x || value)}
            {...DayPickerStyling.modifiers({ allowPast: true })}
        />
        <DateQuickOptions>
            <TableButton onClick={() => onPickInterval(0)}>
                Today
            </TableButton>
            <TableButton onClick={() => onPickInterval(1)}>
                Tomorrow
            </TableButton>
            <TableButton onClick={() => onPickInterval(3)}>
                In 3 days
            </TableButton>
            <TableButton onClick={() => onPickInterval(7)}>
                In 7 days
            </TableButton>
            <TableButton onClick={() => onPickInterval(14)}>
                In 14 days
            </TableButton>
            <TableButton onClick={() => onChange(null)}>
                Clear
            </TableButton>
        </DateQuickOptions>
    </DayPickerStyling>;
};

export const DateBadgeButton = ({ color, value, placeholder, formatter, onChange }: DateButtonProps) => {
    formatter = formatter ?? (d => d?.toLocaleDateString());

    const [open, setOpen] = useState(false);

    const onSelect = (next: Date) => {
        onChange?.(next);
        setOpen(false);
    };

    return <Popover
        placement="bottom-end"
        content={<DatePicker value={value} onChange={onSelect} />}
        inner={{ direction: 'down' }}
        open={open}
        onOpenChange={setOpen}
    >
        <BadgeButton active={open} color={color ?? Colors.white}>
            <span>{!!value ? formatter(value) : placeholder ?? ''}</span>
            <Icon size="1" src="deqo://icons/hero-mini/chevron-down" />
        </BadgeButton>
    </Popover>;
};
